import { Stack } from '@mui/material';
import { Form } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { buttonTextMessages } from '@ocx-app/modules/localization/button-text.messages';

import { TextField } from '@ocx/ui-forms';
import { Button, SizingMultiplier, Typography } from '@ocx/ui';

import { EnterReferralCodeFormValue } from './enter-referral-code-action-sheet.types';

export type EnterReferralCodeActionSheetProps = {
  onSubmit(values: EnterReferralCodeFormValue): void;
  onClose(): void;
};

const initialValues: EnterReferralCodeFormValue = { code: '' };

export const EnterReferralCodeActionSheet = ({ onSubmit, onClose }: EnterReferralCodeActionSheetProps) => {
  const intl = useIntl();

  return (
    <Form<EnterReferralCodeFormValue>
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, dirty }) => (
        <Stack
          component="form"
          noValidate
          onSubmit={handleSubmit}
          spacing={SizingMultiplier.md}
          p={SizingMultiplier.lg}>
          <div>
            <Typography variant="h5" gutterBottom>
              <FormattedMessage id="enter-promocode-action-sheet:title" defaultMessage="Enter your referral code" />
            </Typography>
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage
                id="enter-promocode-action-sheet:description"
                defaultMessage="You can find it in the text message you received from your friend."
              />
            </Typography>
          </div>
          <TextField
            name="code"
            label={intl.formatMessage({
              id: 'referral-code:form-label:referral-code',
              defaultMessage: 'Referral Code',
            })}
            variant="outlined"
            fieldProps={{ parse: (value: string) => value.toUpperCase() }}
            fullWidth
          />
          <Button type="submit" disabled={!dirty} fullWidth>
            <FormattedMessage {...buttonTextMessages['button-text:apply']} />
          </Button>
          <Button variant="text" onClick={onClose} fullWidth>
            <FormattedMessage {...buttonTextMessages['button-text:close']} />
          </Button>
        </Stack>
      )}
    />
  );
};
